/**
 * Slug helpers for routing — endpoints become URL segments.
 *
 * We use `operationId` directly as the slug (it's already URL-safe per the
 * generator) but expose helpers for safety in case spec changes upstream.
 */

export function endpointSlug(operationId: string): string {
  return operationId.replace(/[^a-zA-Z0-9_-]/g, '_');
}

export function tagSlug(tag: string): string {
  return tag.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-|-$/g, '');
}
